import { Tooltip } from '@vtex/admin-ui'
import { FormattedMessage, useIntl } from 'react-intl'
import type { Subscription as SubscriptionType } from 'typings'
import {
  formatCycle,
  formatFrequency,
  formatSubscription,
  formatType,
} from 'ui/components/PromotionForm/Conditions/Subscription/format'
import { Tag } from 'ui/components/Tag'
import { messages } from './messages'

type Props = {
  subscription: SubscriptionType | undefined
}

export function Subscription(props: Props) {
  const intl = useIntl()

  const { subscription } = props

  if (!subscription) return

  const { type } = subscription
  const { cycle, frequency } = subscription.filter

  const processTooltip = (): string => {
    return formatSubscription(
      [
        formatType(type, intl),
        formatFrequency(frequency, intl),
        formatCycle(cycle, intl),
      ],
      intl
    )
  }

  return (
    <Tooltip text={processTooltip()}>
      <Tag>
        <FormattedMessage {...messages.subscription.tag} />
      </Tag>
    </Tooltip>
  )
}
